<template>
    <div>
        <v-row no-gutters>
            <v-col class="mb-2">
                <ModernFilterBar :filter-controller="filterController">
                    <template v-slot:right="{filters, filterAdd}">
                        <AddFilterButton
                            :filters="filters"
                            @add_filter="filterAdd($event)"
                        />

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <icon-button
                                    :on="on"
                                    icon="Delete"
                                    @click="filterController.resetFilters()"
                                />
                            </template>
                            {{ $t("Clear filters") }}
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <icon-button
                                    :on="on"
                                    :disabled="Object.keys($route.query).length < 1"
                                    icon="Save"
                                    @click="onSaveFiltersClick"
                                />
                            </template>
                            {{ $t("Save") }}
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <icon-button
                                    :on="on"
                                    :loading="richDataTableController.isLoading()"
                                    icon="RotateCw"
                                    @click="urlAdapter.updateUrlParameters()"
                                />
                            </template>
                            <span>{{ $t("Update") }}</span>
                        </v-tooltip>
                    </template>
                </ModernFilterBar>
            </v-col>
        </v-row>
        <v-row
            no-gutters
            class="mt-4"
        >
            <v-col>
                <div class="caption grey--text font-weight-medium" style="flex-wrap: nowrap; white-space: nowrap"></div>
                <v-row>
                    <DropMenu
                        :items="f_bookmarks('monitoring')"
                        name-key="name"
                        value-key="id"
                        icon=""
                        :menu-props="{
                            'open-on-hover': false,
                            'offset-y': true
                        }"
                        :custom-rules="activeBookmarkRule"
                        :hover-action="onDeleteBookmarkClick"
                        :show-selected-first="false"
                        enable-hover-action
                        @input="navigate_bookmark($event)"
                    >
                        <template v-slot="{ on }">
                            <v-btn
                                text
                                class="text-none px-3"
                                style="letter-spacing: normal"
                                v-on="on"
                            >
                                <div
                                    class="headline"
                                    style="flex-wrap: nowrap; white-space: nowrap"
                                >
                                    {{
                                        f_bookmarks("monitoring").find(i => activeBookmarkRule(i))
                                            ? f_bookmarks("monitoring").find(i => activeBookmarkRule(i)).name
                                            : $t("Monitoring")
                                    }}
                                </div>
                                <v-icon
                                    right
                                    color="grey"
                                >
                                    mdi-menu-down
                                </v-icon>
                            </v-btn>
                        </template>
                    </DropMenu>
                </v-row>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col>
                <v-row
                    no-gutters
                    align="center"
                >
                    <v-col>
                        <v-row
                            justify="end"
                            no-gutters
                            align="center"
                        >
                            <v-menu
                                content-class="overflow-y-hidden dropmenu"
                                bottom
                                offset-y
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        icon="Download"
                                        :on="on"
                                    />
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="onDownloadReport('create_report_pdf')"
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-file-pdf-box</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("Export PDF") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="onDownloadReport('create_report_excel')"
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-file-excel-box</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("Export Excel") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <ColumnController
                                :headers="richDataTableController.getAllHeaders()"
                                :visible-headers="richDataTableController.getVisibleHeaders().map(x => x.value)"
                                dense
                                @update_columns="richDataTableController.setVisibleHeadersWithoutLoadData($event)"
                            />
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <RichDataTable
                        class="w-100"
                        dense
                        :override-loading-rows="1"
                        :rich-data-table-controller="richDataTableController"
                    >
                        <template v-slot:item.client="{ item }">
                            <div class="d-flex align-center" @click.stop="">
                                <router-link
                                    :to="{ name: 'client_profile', params: { id: item.client_id }}"
                                    class="d-flex align-center"
                                >
                                    <AccountAvatar :inverted="item.status === 'finished'"
                                                   :color="item.client ? item.client.color : item.color"
                                                   :initials="item.client ? item.client.client_initials : item.client_initials"
                                                   :size="21"
                                                   text-class="font-weight-bold"
                                                   tile
                                                   :class="$vuetify.breakpoint.smAndDown ? '' : ''"/>
                                    <div
                                        style="white-space: nowrap; max-width: 250px; text-overflow: ellipsis"
                                        class="ml-2 caption font-weight-regular overflow-hidden"
                                    >
                                        {{ item.client ? item.client.name : item.client_name }}
                                    </div>
                                </router-link>
                            </div>
                        </template>
                        <template v-slot:default="{ item, header }">
                            <MonitoringColumn
                                :header="header"
                                :item="item"
                                :date-from="dateFrom"
                                :date-until="dateUntil"
                                :period-from="periodFrom"
                                :period-until="periodUntil"
                                :period-coefficient="periodCoefficient"
                            />
                        </template>
                    </RichDataTable>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {ref, computed, onUnmounted, reactive} from "@vue/composition-api";
import AddFilterButton from "../../components/ModernFilterBar/components/AddFilterButton";
import {$t} from "@/i18n";
import ReportModule from "../../store/modules/report";
import DialogModule from "../../store/modules/dialog";
import BookmarkMenu from "../../composables/use-bookmark-menu";
import DropMenu from "../../components/NewFilterBar/components/DropMenu";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import AccountModule from "../../store/modules/account";
import ModernFilterBar from "@/components/ModernFilterBar/index.vue";
import UrlAdapter from "@/urlAdapter/urlAdapter";
import RichDataTableController from "@/components/RichDataTable/RichDataTableController";
import FilterBarController from "@/components/ModernFilterBar/FilterBarController";
import ColumnController from "@/components/ColumnController.vue";
import RichDataTable from "@/components/RichDataTable/RichDataTable.vue";
import ApiReport from "@/api/report/report";
import MonitoringColumn from "@/views/Monitoring/MonitoringColumn.vue";
import AccountAvatar from "@/components/AccountAvatar.vue";
import BookmarkModule from "@/store/modules/bookmark";
import CustomFieldsModule from "@/store/modules/custom_fields";
import ReportDefaultColumns from "@/views/Report/ReportDefaultColumns";
import {useTopicStore} from "../../store/modules/topic";
import {useMemberStore} from "../../store/modules/member";

export default {
    name: "MonitoringView",
    components: {
        AccountAvatar,
        MonitoringColumn,
        RichDataTable,
        ColumnController,
        ModernFilterBar,
        DropMenu,
        AddFilterButton
    },
    setup(props) {
        const {navigate_bookmark, f_bookmarks, activeBookmarkRule, onDeleteBookmarkClick} = BookmarkMenu();
        const {
            clients,
            companies,
            client_groups,
            monitoring_fields,
            report,
            clearReports
        } = ReportModule();
        const topicStore = useTopicStore()
        const {openDialog, setDialogOptions} = DialogModule();
        const memberStore = useMemberStore()
        const {available_accounts} = AccountModule();
        const bookmarkModule = BookmarkModule()
        const {fetchCustomFields, account_custom_monitoring_fields} = CustomFieldsModule();
        const { default_task_columns } = ReportDefaultColumns();

        const visibleMembers = computed(() => {
            return memberStore.getAllMembers()
        })

        const periodFrom = ref(null)
        const periodUntil = ref(null)
        const dateFrom = ref(null)
        const dateUntil = ref(null)
        const periodCoefficient = ref(null)

        const isLoading = ref(false);

        const urlAdapter = new UrlAdapter()
        urlAdapter.loadDefaultBookmark('monitoring', bookmarkModule.bookmarks.value)

        /** @type {FilterBarController} */
        const filterController = reactive(FilterBarController.init(urlAdapter))

        urlAdapter.addGetStateCallback((...args) => ({
            view: 'monitoring',
            active_bookmark_id: urlAdapter.getUrlParameter('active_bookmark_id')
        }))

        const options = [
            {key: "sortBy", default_value: ""},
            {key: "sortDesc", default_value: false},
            {key: "itemsPerPage", default_value: 99999},
            {key: "page", default_value: 1}
        ]

        const topics = computed(() => topicStore.getAllTopics(true))

        const filters = computed(() => [
            {
                key: "dates_list",
                default_value: [
                    new Date().calcMonthStart().formatSysDate(),
                    new Date().calcMonthEnd().formatSysDate(),
                    "som_0",
                    "eom_0"
                ],
                extraItems: [
                    {title: $t("This month"), start: "som_0", end: "eom_0"},
                    {title: $t("Last month"), start: "som_-1", end: "eom_-1"},
                ],
                default: true
            },
            {key: "client_group_id_list", default_value: [], items: client_groups, default: true},
            {key: "client_id_list", default_value: [], items: clients, default: true},
            {key: "topic_id_list", default_value: [], items: topics, default: true},
            {key: "account_id_list", default_value: available_accounts.value[0] ? [available_accounts.value[0].id] : [], items: companies, default: true},
            {key: "is_important", default_value: ["1"]},
            {key: "is_extra", default_value: ["1"]},
            {key: "is_recurring", default_value: ["1"]},
            {key: "is_commented", default_value: ["1"]},
            {key: "is_tracked_time", default_value: ["1"]},
            {key: "is_estimated", default_value: ["1"]},
            {key: "default_person_id_list", default_value: [], items: visibleMembers},
        ])

        const fieldColumns = computed(() => {
            let columns = [
                {
                    text: $t('Client'),
                    value: "client",
                    sortable: true,
                    width: 31,
                    removable: false,
                    alwaysVisible: true,
                    default: true
                },
                {
                    text: $t('Period'),
                    value: "period",
                    sortable: false,
                    removable: false,
                    alwaysVisible: true,
                    default: true
                }
            ]

            let company_monitoring_fields = monitoring_fields.value.filter(item => {
                let urlParameter = urlAdapter.getUrlParameter('account_id_list')

                if (!urlParameter) {
                    urlParameter = available_accounts.value[0] ? [available_accounts.value[0].id] : []
                }

                return !item.account_id || urlParameter.includes(item.account_id);
            })
            let result = company_monitoring_fields.map(cf => {
                return {
                    text: cf.title,
                    value: cf.name,
                    type: cf.type,
                    group: cf.group,

                    class: "text-no-wrap",
                    align: "right pl-1", //  : "left pl-1",
                    justify: "end", // : "start"
                    default: true
                }
            });

            columns = columns.concat(result)

            columns.push({
                text: $t('Status'),
                value: "status",
                sortable: false,
                removable: false,
                alwaysVisible: true,
                default: true,
                width: 0
            })

            return columns
        });

        const backendQuery = async (params) => {
            params = {...filterController.getCurrentFilterValues(), ...richDataTableController.getOptions(), ...params}

            try {
                const res = await ApiReport.getReport(params)
                periodFrom.value = res.period_from
                periodUntil.value = res.period_until
                dateFrom.value = res.date_from
                dateUntil.value = res.date_until
                periodCoefficient.value = res.period_coefficient
                richDataTableController.setRows(res.rows, res.row_count)

                richDataTableController.setAllHeaders(fieldColumns.value)

                // When deselecting a company a column is removed, however it is not removed from selected
                // this is technically not an issue unless you download pdf/excel
                const visibleHeaders = richDataTableController.getVisibleHeaders().map(x => x.value)
                const allHeaders = richDataTableController.getAllHeaders()
                const filteredVisibleHeaders = visibleHeaders.filter(visibleHeader => allHeaders.find(x => x.value === visibleHeader))
                await richDataTableController.setVisibleHeadersWithoutLoadData(filteredVisibleHeaders)
            } catch (e) {
                errorDialog.showError(e)
            }
        };

        const onDownloadReport = async act => {
            // "create_report_excel", "create_report_pdf"
            const PROTOCOL = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
            const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
            const BASE_URL = `${PROTOCOL}://${HOST}`;
            const url = new URLSearchParams({
                ...urlAdapter.getUrlParameters(),
                act,
                details: 0,
                report_title: f_bookmarks("report").find(i => activeBookmarkRule(i))
                    ? f_bookmarks("report").find(i => activeBookmarkRule(i)).name
                    : $t("Report")
            }).toString();
            window.open(BASE_URL + "/api/report?" + url);
        };

        const onSaveFiltersClick = () => {
            setDialogOptions({
                component: () => import("@/views/Dialog/BookmarkDialog"),
                payload: {
                    type: "monitoring",
                    title: $t("Save report")
                }
            });
            openDialog();
        };

        onUnmounted(function () {
            clearReports();
        });

        filterController.initFilters(filters.value)
        filterController.setBeforeFilterInputFunc((...a) => filterController.resetFiltersOnAccountChange(...a))

        /** @type {RichDataTableController} */
        const richDataTableController = reactive(RichDataTableController.init(fieldColumns.value, options, urlAdapter, [99999]))

        const onRowClick = item => {
            fetchCustomFields(item.account_id, 'task', 0, false)
                .then(function () {
                    // load custom fields
                    let columns = default_task_columns
                    const acc_custom_fields = account_custom_monitoring_fields(item.account_id);
                    acc_custom_fields.value.forEach(function (elem) {
                        columns.push(elem.name);
                    });

                    // link monitoring view
                    let queryParams = {}
                    queryParams = Object.assign(queryParams, {
                        view: "detailed",
                        groupBy: "client;title",
                        columns: columns,
                        client_id_list: [item.client_id],
                        dates_list: urlAdapter.getUrlParameter('dates_list')
                    });
                    bookmarkModule.navigate_report_default_route(queryParams);
                })
                .catch(ex => errorDialog.showError(ex));
        };

        richDataTableController.setOnRowClick((...a) => onRowClick(...a))
        richDataTableController.setLoadDataFunc(backendQuery)

        richDataTableController.loadUrlState()
        filterController.startUrlWatcher()

        return {
            report,
            fieldColumns,
            f_bookmarks,
            navigate_bookmark,
            activeBookmarkRule,
            onDeleteBookmarkClick,
            backendQuery,
            onSaveFiltersClick,
            onDownloadReport,
            isLoading,
            richDataTableController,
            filterController,
            urlAdapter,
            monitoring_fields,
            periodFrom,
            periodUntil,
            dateFrom,
            dateUntil,
            periodCoefficient
        };
    }
};
</script>

<style scoped lang="scss">
::v-deep .v-data-table.v-data-table--dense td .caption {
    font-weight: 600;
}
</style>